import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) =>
  createStyles({
    selfieImage: {
      // width: "100%",
      maxHeight: "20vh",
    },
    videoButtons: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
    },
    numbers: {
      position: "absolute",
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: 64,
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: 20,
      width: '100%'
    },
    info: {
      textAlign: "center",
    },
    video: {
      width: "100%",
      height: "100%",
      transform: 'rotateY(180deg)',
      '-webkit-transform': 'rotateY(180deg)',
      '-moz-transform': 'rotateY(180deg)'
    },
    frame: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  })
);
